export default __webpack_public_path__ + "static/media/bg_404.31af9ff7.png";